import React from 'react';
import { DataTable as CarbonDataTable, DataTableProps } from '@carbon/react';

export const DataTable = <RowType, ColType extends unknown[]>(
  props: DataTableProps<RowType, ColType>
) => <CarbonDataTable {...props} />;

DataTable.displayName = 'DataTable';
